import { IAction } from "../model/IAction";

export const SWITCH_PARAMETER_EDITOR_MODE = "SWITCH_PARAMETER_EDITOR_MODE";
export function switchParameterEditorMode(parameterId: string, newMode: string): SwitchParameterEditorModeAction {
    return {
        type: SWITCH_PARAMETER_EDITOR_MODE,
        parameterId: parameterId,
        newMode: newMode
    };
}

export interface SwitchParameterEditorModeAction extends IAction {
    parameterId: string;
    newMode: string;
}
